<template>
    <my-form
    v-model="form"
    table
    label-width="180px"
    @cancle="cancleHandler"
    @submit="submitHandler">
        <el-form-item
        class="table-full-row"
        label="项目名称"
        >
            {{form.bdname}}
        </el-form-item>

        <el-form-item
        class="table-full-row"
        label="中标候选人公示是否发布"
        >
            <th-state :readonly="readonly" v-if="!ggReadonly"></th-state>
             <my-tag type="primary" v-if="ggReadonly" class="tip">已提交</my-tag>
        </el-form-item>
        <my-tag type="danger" v-if="ggReadonly" class="tip">不满足退回条件</my-tag>
        <template slot="btn" slot-scope="scope">
            <el-button
            :disabled="ggReadonly||readonly"
            @click="scope.submitHandler"
            type="danger"
            icon="el-icon-circle-check">
                退回
            </el-button>
            <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
        </template>
    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'

import ThState from '../components/th-state'

export default {
    mixins: [ FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    components: { ThState },
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        form: {},

        shbj: '',
       
    }),
    computed: {
        readonly() {
            return (
                this.shbj.indexOf('9') > -1 
             
            );
        },
          ggReadonly() {
            return (
                this.shbj.indexOf('1') > -1 
                || this.shbj.indexOf('6') > -1 
            );
        },
    },
    methods: {
        submitHandler() {
            ShowConfirm('确认退回？','danger',()=> { 
                this.$post(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thzbhxr.json`, this.data, (data, res) => {
                    ShowMsg(res.msg);
                    this.cancleHandler();
                });
            })
        }
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thzbhxrinit.json`, this.data, data => {
            this.form = data.model;
            this.jspDataInit(data, ['shbj']);
        });
    }
}
</script>

<style scoped lang="scss">
 .tip {
     margin:auto;
     margin-top:10px;
 }
</style>
